import { ControlledCardsListSkeleton } from "Components/Shared/CardsList/ControlledCardsListSkeleton";
import { FormSection } from "Components/Shared/FormSection";
import { ValueItemsSkeleton } from "Components/Shared/ValuesBox/ValueItemsSkeleton";
import { ValuesBox } from "Components/Shared/ValuesBox/ValuesBox";
import { AddressType } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { Box } from "@mui/material";

const COMPONENT_RESOURCES = Resources.Components.Merchant;

export const MerchantSkeleton = () => {
  const { t } = useResource();

  return (
    <>
      <Box mb={5}>
        <ValuesBox title={t(Resources.Components.Account.GeneralInformation)}>
          <ValueItemsSkeleton
            labels={[
              t(Resources.Common.CompanyName),
              t(Resources.Common.CompanyNumber),
              t(Resources.Common.PartyTypeLabel),
              t(Resources.Common.Address.Type[AddressType.Headquarters]),
              t(Resources.Common.Phone),
              t(Resources.Common.Email),
            ]}
          />
        </ValuesBox>
      </Box>
      <FormSection legend={t(COMPONENT_RESOURCES.ContactPersons.Title)}>
        <ControlledCardsListSkeleton isReadOnly />
      </FormSection>
      <FormSection legend={t(COMPONENT_RESOURCES.Facilities.Title)}>
        <ControlledCardsListSkeleton isReadOnly />
      </FormSection>
    </>
  );
};
